// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const addLabor = () => ({
    type: actions.CREATE_CLAIM_PIP_LABOR
});

export const changeLaborLocation = (index, location) => ({
    index,
    location,
    type: actions.UPDATE_CLAIM_PIP_LABOR_LOCATION
});

export const changeLaborType = (index, laborType) => ({
    index,
    laborType,
    type: actions.UPDATE_CLAIM_PIP_LABOR_TYPE
});

export const deleteLabor = index => ({
    index,
    type: actions.DELETE_CLAIM_PIP_LABOR
});

export const changeLaborProperty = (index, data, property) => ({
    data,
    index,
    property,
    type: actions.UPDATE_CLAIM_PIP_LABOR_FIELDS
});



// WEBPACK FOOTER //
// ./src/claim/pip/action-creators/labor.js